"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormButtonsLayout = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styled = _interopRequireDefault(require("../../theme/styled"));

var _hooks = require("../../hooks");

var _templateObject, _templateObject2;

var Container = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: grid;\n  grid-template-columns: 1fr;\n  row-gap: ", ";\n  column-gap: ", ";\n  ", "\n"])), function (p) {
  return p.theme.basis.space[6];
}, function (p) {
  return p.theme.basis.space[8];
}, function (p) {
  return p.layout === 'columns' && p.theme.media.min.sm(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    grid-template-columns: 1fr 1fr;\n    & > button:first-of-type {\n      grid-column: 2;\n      grid-row: 1;\n    }\n    & > button:last-of-type {\n      grid-column: 1;\n       grid-row: 1;\n    }\n  "])));
});

var s = {
  Container: Container
};

var FormButtonsLayout = function FormButtonsLayout(_ref) {
  var children = _ref.children;
  var layout = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.config.formButtonsLayout;
  });
  return /*#__PURE__*/_react.default.createElement(s.Container, {
    layout: layout
  }, children);
};

exports.FormButtonsLayout = FormButtonsLayout;